import { json2excel } from 'js2excel';
import ExcelJS from 'exceljs';

export function makeid(length) {
  let result = '';
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function filesizeFormat(fileSize) {
  let formatSize = 0;
  let sufix = '';
  if (fileSize < 1000) {
    formatSize = fileSize;
    sufix = 'bytes';
  } else {
    fileSize /= 1024;
    if (fileSize < 1000) {
      formatSize = fileSize;
      sufix = 'kB';
    } else {
      fileSize /= 1024;
      if (fileSize < 1000) {
        formatSize = fileSize;
        sufix = 'MB';
      } else {
        fileSize /= 1024;
        formatSize = fileSize;
        sufix = 'GB';
      }
    }
  }

  return `${formatSize.toFixed(2)} ${sufix}`;
}

export function timeFormat (currentTime) {
  let hours = String(Math.trunc(currentTime / 3600));
  currentTime = currentTime - (hours * 3600);
  let minutes = String(Math.trunc(currentTime / 60));
  currentTime -= minutes * 60;
  let seconds = String(currentTime)
  let strTime = ''
  if (hours == '0') {
    strTime = `${minutes.length == 1 ? '0' + minutes : minutes}:${seconds.length == 1 ? '0' + seconds : seconds}`;
  } else {
    strTime = `${hours.length == 1 ? '0' + hours : hours}:${minutes.length == 1 ? '0' + minutes : minutes}:${seconds.length == 1 ? '0' + seconds : seconds}`;
  }

  return strTime
}

export function removeURLParameter(url, parameter) {
  //prefer to use l.search if you have a location/link object
  var urlparts = url.split('?');   
  if (urlparts.length >= 2) {

      var prefix = encodeURIComponent(parameter) + '=';
      var pars = urlparts[1].split(/[&;]/g);

      //reverse iteration as may be destructive
      for (var i = pars.length; i-- > 0;) {    
          //idiom for string.startsWith
          if (pars[i].lastIndexOf(prefix, 0) !== -1) {  
              pars.splice(i, 1);
          }
      }

      return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
  }
  return url;
}

export function downloadExcel(data, reportPrefix) {
  /*
  funcion paar descargar un excel
   */
  let dateString = new Date();
  dateString = dateString.toISOString().replace('T','_')
    .replace('Z','').replaceAll('-','_').replace(':','_').replace('.','_')
  try {
    json2excel({
      data,
      name: `${reportPrefix}_${dateString}`,
      // formateDate: 'yyyy/mm/dd'
    });
  } catch (e) {
      console.error('export error', e);
  }
}

export function findAllMatches(regex, testString) {
  /*
  funcion para encontrar todas las coincidencias en una cadena
  dada una expresion regular
   */
  const matches = [];
  var m;
  do {
    m = regex.exec(testString);
    if (m) {
      matches.push(m[0].trim());
    }
  } while (m);
  return matches;
}

export function shuffleArray(array) {
  /**
   * funcion para ordenar de forma aleatorea un Array
   *
   * @param {Array} array ruta a la propiedad separa por puntos
   * @param {} value valor de la propiedad
   * @returns {Array} Array reordenado
   * @example
   * shuffleArray([1, 2, 3, 4, 5])
   * @author Luis Merizalde <luis.merizalde@arcerojas.com> (Google AI)
   */
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]]; // Swap elements
  }
  return array;
}

export function getCadastralDomain(value, domains, originalValue = '') {
  /**
   * funcion para obtener el valor de un dominio catastral
   *
   * @param {String} value ruta a la propiedad separa por puntos
   * @param {Array} domains valor de la propiedad
   * @returns {String} valor del dominio
   * @example
   * getCadastralDomain('A', [{codigo: 'A', nombre: 'Comercial'}])
   * @author Luis Merizalde <luis.merizalde@arcerojas.com> (Google AI)
   */
  let domainValue = `NO DATA (<b>${value}</b>)`;
  const filterDomain = domains.filter((x) => x.codigo === value);
  if (filterDomain.length > 0) {
    domainValue = `${filterDomain[0].nombre} (<b>${originalValue !== '' ? originalValue :value}</b>)`;
  }
  return domainValue;
}

export function processRecordsOne(rawData, economicDestinations) {
  /**
   * funcion para obtener los datos de dominos procesados de registros
   * 1 del IGAC
   *
   * @param {Object} rawData ruta a la propiedad separa por puntos
   * @param {Array} economicDestinations dominio destinos economicos
   * @returns {Object} datos procesados
   * @example
   * processRecordsOne('A', [{codigo: 'A', nombre: 'Comercial'}])
   * @author Luis Merizalde <luis.merizalde@arcerojas.com> (Google AI)
   */
  if (Object.keys(rawData).includes('DESTINO_ECONOMICO')) {
    rawData['DESTINO_ECONOMICO'] = getCadastralDomain(
      rawData['DESTINO_ECONOMICO'], economicDestinations);
  }
  return rawData;
}

export function processRecordsTwo(
  rawData,
  constructionUses,
  typologyUses,
  physicalZones,
  economicZones) {
  /**
   * funcion para obtener los datos de dominos procesados de registros
   * 1 del IGAC
   *
   * @param {Array} rawData listado items R2
   * @param {Array} constructionUses dominio usos construcción
   * @param {Array} typologyUses dominio usos tipologia
   * @param {Array} physicalZones dominio zonas fisicas
   * @param {Array} economicZones dominio zonas economicas
   * @returns {Object} datos procesados
   * @example
   * processRecordsOne('A', [{codigo: 'A', nombre: 'Comercial'}])
   * @author Luis Merizalde <luis.merizalde@arcerojas.com> (Google AI)
   */
  for (let index = 0; index < rawData.length; index++) {
    const element = rawData[index];
    if (Object.keys(element).includes('ZONA_FISICA_1')) {
      if (element['ZONA_FISICA_1'] === '000') {
        element['ZONA_FISICA_1'] = 'NO DATA (<b>000</b>)';
      } else {
        element['ZONA_FISICA_1'] = getCadastralDomain(
          `${element['ZONA_FISICA_1'][0]}00`, physicalZones, element['ZONA_FISICA_1']);
      }
    }
    if (Object.keys(element).includes('ZONA_FISICA_2')) {
      if (element['ZONA_FISICA_2'] === '000') {
        element['ZONA_FISICA_2'] = 'NO DATA (<b>000</b>)';
      } else {
        element['ZONA_FISICA_2'] = getCadastralDomain(
          `${element['ZONA_FISICA_2'][0]}00`, physicalZones, element['ZONA_FISICA_2']);
      }
    }
    if (Object.keys(element).includes('ZONA_ECONOMICA_1')) {
      element['ZONA_ECONOMICA_1'] = getCadastralDomain(
        element['ZONA_ECONOMICA_1'], economicZones);
    }
    if (Object.keys(element).includes('ZONA_ECONOMICA_2')) {
      element['ZONA_ECONOMICA_2'] = getCadastralDomain(
        element['ZONA_ECONOMICA_2'], economicZones);
    }
    if (Object.keys(element).includes('USO_1')) {
      element['USO_1'] = getCadastralDomain(
        element['USO_1'].padStart(2, '0'), constructionUses);
    }
    if (Object.keys(element).includes('USO_2')) {
      element['USO_2'] = getCadastralDomain(
        element['USO_2'].padStart(2, '0'), constructionUses);
    }
    if (Object.keys(element).includes('USO_3')) {
      element['USO_3'] = getCadastralDomain(
        element['USO_3'].padStart(2, '0'), constructionUses);
    }
    if (Object.keys(element).includes('TIPIFICACION_1')) {
      element['TIPIFICACION_1'] = getCadastralDomain(
        element['TIPIFICACION_1'], typologyUses);
    }
    if (Object.keys(element).includes('TIPIFICACION_2')) {
      element['TIPIFICACION_2'] = getCadastralDomain(
        element['TIPIFICACION_2'], typologyUses);
    }
    if (Object.keys(element).includes('TIPIFICACION_3')) {
      element['TIPIFICACION_3'] = getCadastralDomain(
        element['TIPIFICACION_3'], typologyUses);
    }
    
  }
  return rawData;
}

export function formatDate(dateString) {
  /**
   * función formatear la fecha
   *
   * @param {Object} dateString fecha con formato servidor
   * @returns {String} fecha formateada eg: '21/5/2024, 1:54:17 p. m.'
   * @example
   * this.formatDate('2024-05-21T18:54:17.529114+00:00')
   * @author Luis Merizalde <luis.merizalde@arcerojas.com>
   */
  const date = new Date(dateString);
  return date.toLocaleString();
}

export async function exportStyledExcel(
  items, columns, prefixFile = 'reporte', sheetName = 'Datos'
) {
  /**
   * función descargar un excel formateado al estilo de arcerojas
   *
   * @param {Array} items, los datos que van a ser pintados en las tablas
   * @param {Array} columns, las cabeceras del excel
   * @returns {String} fecha formateada eg: '21/5/2024, 1:54:17 p. m.'
   * @example
   * columns = [
   *   { header: 'Nombre', key: 'nombre', width: 20 },
   *   { header: 'Edad', key: 'edad', width: 10 }
   * ]
   * exportStyledExcel(items, columns)
   * @author Luis Merizalde <luis.merizalde@arcerojas.com>
   */
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(sheetName);

  // Agregar encabezados
  worksheet.columns = columns;
  // Insertar datos
  items.forEach((item) => worksheet.addRow(item));

  // Estilo de la primera fila (encabezados)
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF1F4E78' }
    };
  });

  // alinear todas las filas
  const totalRows = items.length + 1;
  for (let index = 1; index < totalRows + 1; index++) {
    worksheet.getRow(index).eachCell((cell) => {
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });
  }

  // Descargar archivo
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type:
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  let dateString = new Date();
  dateString = dateString.toISOString().replace('T', '_')
    .replace('Z', '').replaceAll('-', '_')
    .replace(':', '_')
    .replace('.', '_');
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${prefixFile}_${dateString}.xlsx`;
  link.click();
  return true;
}

export function cleanHeaders(headers, width = 20, excludedColumns = []) {
  /**
   * función procesar columnas de datatables y pasarlas a excel
   *
   * @param {Array} headers, columns fecha con formato servidor
   * @returns {String} fecha formateada eg: '21/5/2024, 1:54:17 p. m.'
   * @example
   * headers = [
   *   {
   *     text: '#',
   *     value: 'id',
   *     sortable: false,
   *   },
   *   {
   *     text: 'Nombre Capa/Seccion',
   *     align: 'start',
   *     sortable: false,
   *     value: 'name',
   *   },
   * ]
   * cleanHeaders(columns)
   * @author Luis Merizalde <luis.merizalde@arcerojas.com>
   */
  let rawHeaders = JSON.parse(JSON.stringify(headers));
  // filtrar las columnas excluidas
  rawHeaders = rawHeaders.filter((x) => !excludedColumns.includes(x.value));
  for (let index = 0; index < rawHeaders.length; index++) {
    const element = rawHeaders[index];
    if (element.sortable) delete element.sortable;
    if (element.align) delete element.align;
    element.header = element.text;
    delete element.text;
    element.key = element.value;
    delete element.value;
    element.width = width;
  }
  return rawHeaders;
}
